import React, { useEffect, useState } from "react";
import StudentLeftside from "./StudentLeftside";
import Swal from "sweetalert2";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import API_BASE_URL from "../config/api";
import { color } from "framer-motion";


export default function CompleteProfile() {

  const navigate = useNavigate();

  

  const getUser = () => {
    try {
      const raw = sessionStorage.getItem("user");
      return raw ? JSON.parse(raw) : null;
    } catch {
      return null;
    }
  };

  const [user] = useState(getUser());
  const [mobile, setMobile] = useState("");
  const [otp, setOtp] = useState("");
  const [otpSent, setOtpSent] = useState(false);
  const [progress, setProgress] = useState(80);

  /* ================= CHECK USER ================= */

  useEffect(() => {

    if (!user?.id) {

      Swal.fire({
        icon: "warning",
        title: "Session expired",
        text: "Please login again"
      }).then(() => {

        navigate("/login");

      });

    }

  }, [user, navigate]);

  /* ================= SEND OTP ================= */

  const sendOtp = async () => {

    if (!/^[0-9]{10}$/.test(mobile)) {

      Swal.fire("Invalid Mobile", "Enter valid 10 digit number", "warning");
      return;

    }

    try {

      const res = await axios.post(`${API_BASE_URL}/send_mobile_otp.php`, {
        user_id: user.id,
        mobile: mobile
      });
     // console.log("Send OTP Response:", res);
      if (res.data.success) {

        setOtpSent(true);

        Swal.fire({
          icon: "success",
          title: "OTP Sent",
          text: "OTP sent to your mobile",
           timer: 1200, 
          showConfirmButton: false
        });

      } else {

        Swal.fire("Alert", res.data.message);

      }

    } catch {

      Swal.fire("Error", "Server error while sending OTP");

    }

  };

  /* ================= VERIFY OTP ================= */

  const verifyOtp = async () => {

    if (!otp) {

      Swal.fire("Enter OTP");
      return;

    }

    try {

      const res = await axios.post(`${API_BASE_URL}/verifyotp.php`, {
        userid: user.id,
        mobile: mobile,
        otp: otp
      });

        if (res.data.success) {
              sessionStorage.setItem("verifyNo", "Y");
          Swal.fire({
            icon: "success",
            title: "Profile Completed",
            text: "Mobile verified successfully",
            confirmButtonColor: "#176fb0",
               timer: 1200, 
          showConfirmButton: false
          }).then(() => {
             navigate("/subscription");
          });
        } else {
          Swal.fire("Invalid OTP");
        }

    } catch {

      Swal.fire("Error verifying OTP");

    }

  };

  if (!user) return null;

  return (

    <div className="dashboard-wrap bg-light">

      {/* LEFT MENU */}
      <StudentLeftside />

      <div className="dashboard-content container-fluid py-4 pt-8">

        {/* ===== PAGE TITLE ===== */}
        <div className="dashboard-tlbar mb-2 quiz-section mb-">

          <h5 className="fw-bold text-start" style={{marginTop:"4px", color:"rgb(238 156 15)"}}>
            Complete  Your Profile
          </h5>

        </div>

        <div className="row justify-content-center mb-5">

          <div className="col-lg-12">

            <div className="card shadow-lg border-0">

              <div className="card-body p-4">

                {/* ===== WELCOME ===== */}

              <h4 className="mb-3">
  Welcome{" "}
  <span style={{ color: "#164D85", fontWeight: "bold" }}>
    {user?.name}
  </span>
</h4>

                <p className="text-muted">
                  Your account was created using Google.  
                  Please complete your profile to continue.
                </p>

                <hr />

                {/* ===== GOOGLE INFO ===== */}

                {/* Google Information fields only, heading removed */}
                <div className="row mb-3">
                  <div className="col-md-6 mb-2 mb-md-0">
                    <label className="form-label fw-semibold">Name</label>
                    <input
                      type="text"
                      className="form-control"
                      value={user?.name || ''}
                      disabled
                    />
                  </div>
                  <div className="col-md-6">
                    <label className="form-label fw-semibold">Email</label>
                    <input
                      type="email"
                      className="form-control"
                      value={user?.email_id || ''}
                      disabled
                    />
                  </div>
                </div>
                {/* ===== PROFILE PROGRESS ===== */}

                <h5 className="mb-2">Profile Completion</h5>

                <div
                  className="progress mb-2"
                  style={{
                    height: "14px",
                    borderRadius: "20px"
                  }}
                >

                    <div className="progress mb-2" style={{ height: "14px", borderRadius: "20px" }}>
  <div
    className="progress-bar"
    role="progressbar"
    style={{
      width: `${progress}%`,
      backgroundColor: '#28a745',
      color: '#fff',
      borderRadius: "20px",
      fontWeight: 'bold',
      fontSize: '13px',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      transition: 'width 0.5s ease'
    }}
    aria-valuenow={progress}
    aria-valuemin="0"
    aria-valuemax="100"
  >
    {progress}%
  </div>
</div>

                </div>

                <p className="text-muted mb-3">
                  Your profile is <b>{progress}% complete</b>. Add your mobile number to finish setup.
                </p>

                <hr />

                {/* ===== MOBILE INPUT ===== */}

                <div className="mb-3">

                  <label className="form-label fw-semibold">
                    Mobile Number *
                  </label>

                  <input
                    type="tel"
                    className="form-control"
                    value={mobile}
                    onChange={(e) => setMobile(e.target.value)}
                    placeholder="Enter mobile number"
                    maxLength="10"
                  />

                </div>

                {!otpSent && (

                  <button
                    className="btn btn-primary"
                    onClick={sendOtp}
                  >
                    Send OTP
                  </button>

                )}

                {otpSent && (

                  <>

                    <div className="mt-3">

                      <label className="form-label fw-semibold">
                        Enter OTP
                      </label>

                      <input
                        type="text"
                        className="form-control"
                        value={otp}
                        onChange={(e) => setOtp(e.target.value)}
                        placeholder="Enter OTP"
                      />

                    </div>

                    <button
                      className="btn btn-success mt-3"
                      onClick={verifyOtp}
                    >
                      Verify OTP
                    </button>

                  </>

                )}

              </div>

            </div>

          </div>

        </div>

      </div>

    </div>

  );

}